import axios from 'axios';
import Constants from '../constants';
import { ITranslationEditItem } from '../models/ITranslationEditItem';

export interface ITranslationApiParameters {
	apiUrl: string;
	uniqueId: number;
}

export async function getTranslations(params: ITranslationApiParameters): Promise<ITranslationEditItem[]> {
	const url = params.apiUrl + '?uniqueId=' + params.uniqueId;
	try {
		const res = await axios.get(url, { headers: { Pragma: 'no-cache' } });
		return res.data;
	} catch (Error) {
		// unhandled
	}
	throw new Error('An error occurred while fetching Translations.');
}

export async function getAllTranslations(surveyId: number, property: 'Questions'): Promise<{ [uniqueId: number]: ITranslationEditItem[] }> {
	const response = await axios.get<{ [uniqueId: number]: ITranslationEditItem[] }>(
		`${Constants.API_TRANSLATIONS_URL}/${surveyId}/${property}`,
		{ headers: { Pragma: 'no-cache' } },
	);
	return response.data;
}

export async function saveTranslations(
	params: ITranslationApiParameters,
	defaultCultureCode: string,
	translations: ITranslationEditItem[],
): Promise<ITranslationEditItem[]> {
	const parameters = {
		uniqueId: params.uniqueId,
		defaultCulture: defaultCultureCode,
		translations,
	};
	try {
		const result = await axios.post(params.apiUrl, parameters);
		return result.data;
	} catch {
		// unhandled
	}
	throw new Error('An error occured while saving Translations.');
}

export async function saveAllTranslations(
	surveyId: number,
	property: 'Questions',
	translations: { [uniqueId: number]: ITranslationEditItem[] },
): Promise<{ [uniqueId: number]: ITranslationEditItem[] }> {
	const response = await axios.post<{ [uniqueId: number]: ITranslationEditItem[] }>(
		`${Constants.API_TRANSLATIONS_URL}/${surveyId}/${property}`,
		translations,
		{
			headers: { Pragma: 'no-cache' },
		},
	);
	return response.data;
}
